import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromDeclineProtection from '../actions/decline.protection.action';
import { tap } from 'rxjs/operators';
import { GaEventService } from '@analytics/services/ga.event.service';

@Injectable()
export class DeclineProtectionEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly gaEventService: GaEventService
  ) {}

  declinedProtection$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromDeclineProtection.declineProtection),
        tap(() => this.gaEventService.AdditionalServicesRejectNewPolicy())
      ),
    { dispatch: false }
  );
}
